var exports = {
  "kL": "x620889e6--408314--container",
  "Yv": "x620889e6--408314--about-coworking-container",
  "K2": "x620889e6--408314--logo-container",
};

module.exports = exports;
